module.exports = __webpack_public_path__ + "static/media/o17.128a8024.png";